export const DETOX_PROMPTS = [
  {
    day: 1,
    theme: 'O Ponto de Partida',
    emoji: '🌱',
    prompt: 'O que você faz quando sente tédio? Descreva o primeiro impulso que vem quando você não sabe o que fazer com as mãos.',
  },
  {
    day: 2,
    theme: 'Identidade e Validação',
    emoji: '🪞',
    prompt: 'Quem você é sem a validação do like? O que você posta, e por quê? O que você nunca postaria, e o que isso diz sobre você?',
  },
  {
    day: 3,
    theme: 'O que você evitava',
    emoji: '🌊',
    prompt: 'O que você evitava sentir quando abria o feed? Que emoção o scroll interrompia antes que você pudesse senti-la por completo?',
  },
  {
    day: 4,
    theme: 'Metade do caminho',
    emoji: '🔦',
    prompt: 'O que você já descobriu sobre si mesmo nesses 3 dias? O que te surpreendeu — sobre seus hábitos, seus pensamentos, sua relação com o tempo?',
  },
  {
    day: 5,
    theme: 'O tempo que voltou',
    emoji: '⏳',
    prompt: 'O que você fez com o tempo que ganhou? Foi confortável ou desconfortável ter esse espaço? O que você escolheu preencher — e o que você deixou em branco?',
  },
  {
    day: 6,
    theme: 'Presença Real',
    emoji: '🤝',
    prompt: 'Qual relação presencial ficou mais rica essa semana? Houve uma conversa, um momento, um olhar que você não teria percebido se estivesse com o celular na mão?',
  },
  {
    day: 7,
    theme: 'Quem você quer ser',
    emoji: '🦋',
    prompt: 'Quem você quer ser depois do detox? Você vai voltar às redes da mesma forma, ou algo mudou? Escreva uma promessa para a versão de você que vai carregar essa semana para frente.',
  },
];

export const SCREEN_TIME_OPTIONS = [
  { value: 'menos de 1h', label: 'Menos de 1h' },
  { value: '1h-2h',       label: '1h – 2h' },
  { value: '2h-3h',       label: '2h – 3h' },
  { value: '3h-4h',       label: '3h – 4h' },
  { value: '4h-5h',       label: '4h – 5h' },
  { value: '5h+',         label: 'Mais de 5h 😬' },
];

export const DIFFICULTY_OPTIONS = [
  { value: 1, label: 'Fácil',   emoji: '😌' },
  { value: 2, label: 'Médio',   emoji: '😅' },
  { value: 3, label: 'Difícil', emoji: '😤' },
];
